const API_PATH = "/auto/auto-businesses";
const AUTO_BUSINESS_ID = "~"; // will always be this for now

enum Env {
  Prod = "prod",
  QA = "qa",
  Dev = "dev",
  Local = "local",
}

const HOSTNAMES: Record<Env, string> = {
  [Env.Prod]: "dealernavigator.com",
  [Env.QA]: "qa.dealernavigator.com",
  [Env.Dev]: "featureddealer-mfe-dev.clouddqt.capitalone.com",
  [Env.Local]: "localhost",
};

const API_HOSTS: Partial<Record<Env, string>> = {
  [Env.Dev]: "https://featureddealer-ms-dev.clouddqt.capitalone.com",
};

function getEnv(): Env {
  return (
    (Object.entries(HOSTNAMES).find(
      ([, h]) => h === location.hostname,
    )?.[0] as Env) ?? Env.Local
  );
}

function getApiBase(): string {
  const apiHost = API_HOSTS[getEnv()];
  return apiHost ? `${apiHost}${API_PATH}` : API_PATH;
}

export function apiUrl(dealerId: string, apiName: string): string {
  return `${getApiBase()}/${AUTO_BUSINESS_ID}/locations/${dealerId}/featured-dealer/${apiName}`;
}

// TODO - this may need to be adjusted based on the environment during integration with QA & PROD
export function apiHeaders(): HeadersInit {
  return {
    Accept: "application/json;v=1.0",
    "Content-Type": "application/json",
  };
}
